import React from 'react';

// ✅ 移除 motion.span 動畫，純顯示，React.memo 避免重複渲染
const TagList = React.memo(({ value, color = 'indigo', emptyText = '-' }) => {
  if (!value) return <span className="text-gray-400">{emptyText}</span>;

  const tags = typeof value === 'string' 
    ? value.split(',').map(t => t.trim()).filter(t => t)
    : Array.isArray(value) ? value : [value];

  if (tags.length === 0) return <span className="text-gray-400">{emptyText}</span>;

  const colorMap = {
    blue:   'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
    green:  'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
    red:    'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
    yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300',
    purple: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
    pink:   'bg-pink-100 text-pink-800 dark:bg-pink-900/40 dark:text-pink-300',
    indigo: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300',
    gray:   'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    orange: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
    teal:   'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300',
  };

  const tagColor = colorMap[color] || colorMap.indigo;

  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((tag, index) => (
        <span key={index} className={`px-2 py-1 rounded-full text-xs font-medium ${tagColor}`}>
          {tag}
        </span>
      ))}
    </div>
  );
});

TagList.displayName = 'TagList';
export default TagList;